<template>
  <v-app>
    <CoreDialog
      v-model="isOpened"
      data-qa="banner-mt-link-modal"
      size="fullscreen"
      content-class="mtlink-modal"
      persistent
    >
      <template #prependBtn="{ btnProps }">
        <v-btn
          v-bind="btnProps"
          @click="handleCloseModal"
        >
          <span class="ui-icon-close-not-a-circle" />
        </v-btn>
      </template>

      <div class="flex-grow-1">
        <BannerMtLinkSlider class="pb-2" />
      </div>
      <template #actions>
        <v-btn
          data-qa="modal-actions-btn-confirm"
          color="primary"
          block
          depressed
          @click="handleInstallApp"
        >
          Установить приложение
        </v-btn>
        <v-btn
          data-qa="modal-actions-btn-close"
          color="primary"
          block
          text
          @click="handleCloseModal"
        >
          Закрыть
        </v-btn>
      </template>
    </CoreDialog>
  </v-app>
</template>

<script>
import YaGoals from 'www/modules/YandexGoals'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import BannerMtLinkSlider from 'www/vue_components/common/BannerMtLink/components/common/BannerMtLinkSlider.vue'

export default {
  name: 'BannerMtLinkModal',
  components: {
    CoreDialog,
    BannerMtLinkSlider,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    appLinks: {
      android: 'https://play.google.com/store/apps/details?id=ru.medtochka',
      ios: 'https://apps.apple.com/ru/app/%D0%BC%D0%B5%D0%B4%D1%82%D0%BE%D1%87%D0%BA%D0%B0/id1591602076',
    },
    instanceYaGoals: new YaGoals(),
  }),
  computed: {
    isIOS() {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent)
    },
    appLinkForUserAgent() {
      return this.isIOS
        ? this.appLinks.ios
        : this.appLinks.android
    },
    isOpened: {
      get() {
        return this.isVisible
      },
      set(value) {
        if (value) {
          this.$emit('input', value)
        } else {
          this.$emit('modal:close')
        }
      },
    },
  },
  methods: {
    handleInstallApp() {
      window.open(this.appLinkForUserAgent, '_blank')

      this.instanceYaGoals.send({
        name: 'mtlinkModal__installApp',
      })
    },
    handleCloseModal() {
      this.$emit('modal:close')
    },
  },
}
</script>

<style lang="scss">
.mtlink-modal {
  .core-dialog__actions {
    flex-direction: column;
  }
}
</style>
